import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="zigzag"></div>
      
      <div className="section-header">
        <h2>SERVICES & PRICING</h2>
        <div className="header-ornament">◆ ◆ ◆</div>
        <p>Transform your space with custom Art Deco pattern design with groovy 70s vibes</p>
      </div>
      
      <div className="services-grid">
        <div className="service-card art-deco-border">
          <div className="service-icon">
            <span className="ornament">◆</span>
          </div>
          <h3>ROOM CONSULTATION</h3>
          <div className="price">$150</div>
          <p>Comprehensive room design consultation with custom color schemes and themes tailored to your space</p>
          <ul className="service-features">
            <li>Color palette development</li>
            <li>Pattern recommendations</li>
            <li>Theme coordination</li>
            <li>Implementation guidance</li>
          </ul>
          <button className="service-btn">BOOK CONSULTATION</button>
        </div>
        
        <div className="service-card art-deco-border">
          <div className="service-icon">
            <span className="ornament">●</span>
          </div>
          <h3>SAMPLES & DRAWINGS</h3>
          <div className="price">$200</div>
          <p>Custom pattern samples and detailed drawings delivered directly to your email for your review</p>
          <ul className="service-features">
            <li>Custom pattern design</li>
            <li>Color variations</li>
            <li>Digital samples</li>
            <li>Email delivery</li>
          </ul>
          <button className="service-btn">ORDER SAMPLES</button>
        </div>
        
        <div className="service-card premium art-deco-border">
          <div className="service-icon">
            <span className="ornament">▲</span>
          </div>
          <h3>MANUFACTURING PARTNERSHIPS</h3>
          <div className="price">CUSTOM QUOTE</div>
          <p>Bulk pattern licensing and custom design services for manufacturing clients</p>
          <ul className="service-features">
            <li>Exclusive licensing options</li>
            <li>Custom pattern development</li>
            <li>Production-ready files</li>
            <li>Tailored terms</li>
          </ul>
          <button className="service-btn premium-btn">CONTACT FOR TERMS</button>
        </div>
      </div>
      
      <div className="service-note">
        <div className="note-content art-deco-border">
          <h4>MANUFACTURING CLIENTS</h4>
          <p>Terms will be discussed exclusively with manufacturing partners. Account details and payment terms will be provided once agreement is reached. Contact us directly to discuss your specific needs and volume requirements.</p>
          <div className="note-ornament">◆ ● ◆</div>
        </div>
      </div>
      
      <div className="zigzag"></div>
    </section>
  );
};

export default Services;